/**
 * Instancia personalizada de Axios para peticiones HTTP en
 * la aplicación CRM.
 *
 * Características principales:
 * - Usa `base_url` como baseURL por defecto.
 * - Si la ruta es 'graphql', usa `api_url` como baseURL si
 *   está definida.
 * - Timeout de 60 segundos en cada petición.
 * - Agrega automáticamente los encabezados:
 *    - Authorization: Bearer <token> (si existe)
 *    - id: <id> (si existe) Ambos obtenidos desde
 *      localStorageService.getSessionTokenAndId().
 * - El interceptor modifica la baseURL solo si la ruta es
 *   exactamente 'graphql'.
 *
 * Uso:
 *   import axiosClient from './axiosClient.js';
 *   axiosClient.get('/ruta')
 *     .then(response => {  })
 *     .catch(error => {  });
 *
 * Notas:
 * - Si no hay token o id, los encabezados no se agregan.
 */
import axios from 'axios';
import { localStorageService } from './localStorageService.js';

const axiosClient = axios.create({
  baseURL: base_url,
  timeout: 60000,
});

function addSessionParams(config) {
  const { token, id } = localStorageService.getSessionTokenAndId();
  config.headers = config.headers || {};
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  if (id) {
    config.headers['id'] = id;
  }
  return config;
}

axiosClient.interceptors.request.use(
  (config) => {
    // Cambiar baseURL si la URI es 'graphql'
    if (config.url && config.url.replace(/^\//, '') === 'graphql') {
      config.baseURL = typeof api_url !== 'undefined' ? api_url : config.baseURL;
    }
    return addSessionParams(config);
  },
  (error) => Promise.reject(error),
);

export default axiosClient;
